<template>
  <section>
    <UnifiedFilterSearch
      :filterList="filterList"
      :itensFilter="getItemsFilter"
      showMigrated
      bookmarkType="archived_bookmarks"
      :tabPersistName="tabPersistName"
      @search-value="getSearchValue"
      @filters="getFilterList"
    />
    <div class="level">
      <div class="level-left has-text-left">
        <span class="has-text-weight-semibold">
          {{ getPaginationDetails }}
        </span>
        <span class="radio-container" role="radiogroup">
          <b-radio
            v-model="viewSector"
            :type="isContrast ? 'is-white-dark' : 'is-primary'"
            class="has-text-weight-semibold"
            nativeValue="INDIVIDUAL"
            :disabled="!hasPermissionViewSector"
            role="radio"
            >{{ General.INDIVIDUAL }}</b-radio
          >
          <b-radio
            v-model="viewSector"
            :type="isContrast ? 'is-white-dark' : 'is-primary'"
            class="has-text-weight-semibold"
            nativeValue="SECTOR"
            :disabled="!hasPermissionViewSector"
            role="radio"
            >{{ General.SECTOR }}</b-radio
          >
          <b-radio
            v-model="viewSector"
            :type="isContrast ? 'is-white-dark' : 'is-primary'"
            class="has-text-weight-semibold"
            nativeValue="SECTOR_AND_SUBORDINATES"
            :disabled="!hasPermissionViewSectorAndSubordinates"
            role="radio"
            >{{ App.DashboardScreen.SECTOR_AND_SUBORDINATES }}</b-radio
          >
        </span>
      </div>
      <div class="level-right">
        <div v-if="!isValidSelection" class="buttons">
          <b-tooltip
            multilined
            class="mr-5"
            :type="isContrast ? 'is-white-dark' : 'is-blue-oil'"
            size="is-large"
            position="is-top"
            :label="General.TEXTS.UNABLE_TO_UNARCHIVED"
            :active="!inActualCapacity"
          >
            <b-button
              v-if="hasPermission(userPermissions['UNARCHIVE_PROCESS'])"
              :type="isContrast ? 'is-white-dark' : 'is-primary'"
              :disabled="!inActualCapacity"
              role="button"
              @click="showArchiveModal"
            >
              <span>
                {{ General.UNARCHIVE }}
              </span>
            </b-button>
          </b-tooltip>

          <b-button
            :type="isContrast ? 'is-white-dark' : 'is-primary'"
            role="button"
            @click="checkIsConfidential(getProcessesListCompleteFile)"
          >
            <span>
              {{ General.EXPORT_PDF }}
            </span>
          </b-button>
        </div>
      </div>
    </div>
    <div v-if="observerPage" class="middle">
      <b-table
        class="custom-table-process-panel custom-5-columns"
        :data="archiveList.list"
        :sortIcon="sortIcon"
        :sortIconSize="sortIconSize"
        :checkedRows.sync="selectedProcessArchive"
        :aria-next-label="General.NEXT_PAGE"
        :aria-previous-label="General.PREVIOUS_PAGE"
        :aria-page-label="General.PAGE"
        :aria-current-label="General.CURRENT_PAGE"
        :defaultSort="sortOrder"
        backendSorting
        :checkable="!isMobile"
        hoverable
        role="table"
        :loading="isLoading"
        @sort="onSort"
      >
        <template>
          <b-table-column
            v-slot="props"
            field="default"
            :label="isMobile ? '' : 'hiddenText'"
            headerClass="icons hidden-text"
            cellClass="icons"
            :sortable="!isMobile"
          >
            <div class="process-icons archived-icons">
              <b-tooltip
                v-if="isConfidential(props.row)"
                :type="isContrast ? 'is-white' : 'is-blue-oil'"
                :position="isMobile ? 'is-left' : 'is-top'"
                :label="secrecyName(props.row)"
                role="tooltip"
              >
                <div class="circle-red">
                  <b-icon
                    type="is-white"
                    icon="lock"
                    customSize="mdi-inherit"
                  />
                </div>
              </b-tooltip>
              <b-tooltip
                v-if="subjectIcons[props.row.priority.type]"
                :label="props.row.priority.name"
                :type="isContrast ? 'is-white-dark' : 'is-blue-oil'"
                :position="isMobile ? 'is-left' : 'is-top'"
              >
                <b-icon
                  class="custom-flex-item"
                  :icon="subjectIcons[props.row.priority.type].icon"
                  :type="subjectIcons[props.row.priority.type].color"
                />
              </b-tooltip>
              <b-tooltip
                v-if="props.row.process_join_set.length"
                :type="isContrast ? 'is-white-dark' : 'is-blue-oil'"
                :position="isMobile ? 'is-left' : 'is-top'"
              >
                <template v-slot:content>
                  <span class="has-text-weight-semibold">
                    {{ General.TEXTS.PROCESSES_APPENDERS }}
                  </span>
                  <div
                    v-for="(appendedProcess, index) in props.row
                      .process_join_set"
                    :key="index"
                  >
                    {{ applyMaskNUP(appendedProcess.nup) }}
                  </div>
                </template>
                <b-icon
                  :type="isContrast ? 'is-white-dark' : 'is-blue-oil'"
                  icon="link-variant"
                />
              </b-tooltip>
              <b-tooltip
                v-if="props.row.status_doe"
                :label="showStatusDOE(props.row.status_doe)"
                :type="isContrast ? 'is-white-dark' : 'is-blue-oil'"
                :position="isMobile ? 'is-left' : 'is-top'"
              >
                <b-icon
                  :type="colorStatusDOE(props.row.status_doe)"
                  icon="text-box-check"
                />
              </b-tooltip>
            </div>
          </b-table-column>

          <b-table-column
            v-slot="props"
            field="nup"
            :label="General.NUP"
            :visible="isMobile"
          >
            <span class="has-text-color-8">
              {{ applyMaskNUP(props.row.nup) }}
            </span>
          </b-table-column>

          <b-table-column
            v-slot="props"
            field="subject_name"
            :label="General.SUBJECT"
            :sortable="!isMobile"
          >
            <div class="has-text-left">
              <routerLink
                class="has-text-color-8 has-text-weight-semibold custom-hover"
                role="link"
                rel="search tag"
                :to="`/app/processos/detalhamento/${props.row.id}`"
              >
                {{ isMobile ? "" : `${applyMaskNUP(props.row.nup)} - ` }}
                {{ props.row.subject_name }}
              </routerLink>

              <div v-if="!isMobile" class="has-text-color-8">
                <span class="has-text-weight-semibold">
                  {{ General.ORIGIN_PROCEDURE }}:
                </span>
                <b-tooltip
                  multilined
                  :label="
                    props.row.from_capacity.replace(
                      /([\w-]+)\/([\w-]+)\/([\w-]+) (.+)/g,
                      '$1/$3 $4'
                    )
                  "
                  :type="isContrast ? 'is-white-dark' : 'is-blue-oil'"
                  size="is-small"
                >
                  <span>
                    {{
                      (props.row.from_capacity || "").replace(
                        /([\w-]+)\/([\w-]+)\/([\w-]+) (.+)/g,
                        "$1/$3"
                      )
                    }}
                  </span>
                </b-tooltip>
              </div>
              <section v-if="props.row.observation">
                <span class="has-text-weight-semibold">
                  {{ General.NOTES }}:
                </span>
                {{ props.row.observation }}
              </section>
            </div>
            <div
              v-if="props.row.bookmark.length && !isMobile"
              class="bookmark-container"
            >
              <b-tag
                v-for="(tag, index) in props.row.bookmark.length <= 3
                  ? props.row.bookmark
                  : props.row.bookmark.slice(0, 2)"
                :key="index"
                rounded
                :style="
                  `background-color: ${tag.backgroundColor}; color: ${tag.color}`
                "
              >
                {{ tag.name }}
              </b-tag>
              <b-tag
                v-if="props.row.bookmark.length > 3"
                rounded
                :type="isContrast ? 'is-white-dark' : 'is-blue-oil'"
                >E outros.
              </b-tag>
            </div>
          </b-table-column>

          <b-table-column
            v-slot="props"
            field="last_tramited_date"
            :label="General.FROM"
            :visible="isMobile"
          >
            <div class="has-text-color-8">
              <b-tooltip
                multilined
                :label="
                  props.row.from_capacity.replace(
                    /([\w-]+)\/([\w-]+)\/([\w-]+) (.+)/g,
                    '$1/$3 $4'
                  )
                "
                :type="isContrast ? 'is-white-dark' : 'is-blue-oil'"
                size="is-small"
              >
                <span>
                  {{
                    (props.row.from_capacity || "").replace(
                      /([\w-]+)\/([\w-]+)\/([\w-]+) (.+)/g,
                      "$1/$3"
                    )
                  }}
                </span>
              </b-tooltip>
            </div>
          </b-table-column>

          <b-table-column
            v-slot="props"
            field="last_tramited_date_es"
            :label="General.ARCHIVED"
            :sortable="!isMobile"
          >
            <div>
              <div class="is-inline-mobile has-text-color-8">
                {{
                  new Date(props.row.last_tramited_date)
                    | dateFormat("DD/MM/YYYY")
                }}
              </div>
              <div class="is-inline-mobile has-text-color-8">
                {{ getReceivedDifferenceDate(props.row.last_tramited_date) }}
              </div>
            </div>
            <ProcessStatus :process="props.row" :statusList="['MIGRATED']" />
          </b-table-column>

          <b-table-column v-slot="props" :visible="isMobile">
            <div v-if="props.row.bookmark.length" class="bookmark-container">
              <b-tag
                v-for="(tag, index) in props.row.bookmark.length <= 3
                  ? props.row.bookmark
                  : props.row.bookmark.slice(0, 2)"
                :key="index"
                rounded
                :style="
                  `background-color: ${tag.backgroundColor}; color: ${tag.color}`
                "
              >
                {{ tag.name }}
              </b-tag>
              <b-tag
                v-if="props.row.bookmark.length > 3"
                rounded
                :type="isContrast ? 'is-white-dark' : 'is-blue-oil'"
                >E outros.
              </b-tag>
            </div>
          </b-table-column>

          <b-table-column
            v-slot="props"
            field="user.last_name"
            :label="isMobile ? '' : General.ACTIONS"
          >
            <ActionsGrouper :actions="actionList(props.row)" customClass="" />
          </b-table-column>
        </template>

        <template slot="empty">
          <section class="section">
            <NoListMessage v-if="!isLoading" />
          </section>
        </template>

        <template slot="footer">
          <div class="table-footer">
            <div class="column is-12 number-page pl-0">
              <span
                class="has-text-black column is-12 pl-0 has-text-weight-normal"
              >
                <b-dropdown
                  v-model="perPage"
                  role="listbox"
                  :expanded="isMobile"
                  position="is-top-right"
                >
                  <template slot="trigger">
                    <b-button
                      class="custom-dropdown-button custom-ph-8"
                      role="button"
                    >
                      <label
                        >{{ perPage }}
                        {{ General.PER_PAGE.toLowerCase() }}</label
                      >

                      <b-icon class="spacing-mx-5" icon="chevron-down" />
                    </b-button>
                  </template>
                  <div class="has-text-color-8 spacing-p-5 has-text-centered">
                    {{ General.RECORDS_FOR_PAGE }}
                    <div class="list-page">
                      <b-dropdown-item
                        v-for="option in optionsPagination"
                        :key="option"
                        :value="option"
                        role="listitem"
                      >
                        <div>
                          {{ option }}
                        </div>
                      </b-dropdown-item>
                    </div>
                  </div>
                </b-dropdown>
              </span>
            </div>
            <div class="columns is-centered">
              <div class="column is-6">
                <b-pagination
                  :total="archiveList.count"
                  :perPage="perPage"
                  :current.sync="currentPage"
                  rangeBefore="1"
                  rangeAfter="1"
                  order="is-centered"
                  class="process-panel-pagination"
                  rounded
                  :iconPrev="prevIcon"
                  :iconNext="nextIcon"
                  :aria-next-label="General.NEXT_PAGE"
                  :aria-previous-label="General.PREVIOUS_PAGE"
                  :aria-page-label="General.PAGE"
                  :aria-current-label="General.CURRENT_PAGE"
                  role="navigation"
                />
              </div>
            </div>
          </div>
        </template>
      </b-table>
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import UnifiedFilterSearch from "@/components/UnifiedFilterSearch";
import NoListMessage from "@/components/NoListMessage";
import ProcessStatus from "@/components/ProcessStatus";
import { App, General } from "@/utils/constants";
import { NUP, applyMask } from "@/utils/protocols";
import { showStatusDOE, colorStatusDOE } from "@/utils/processesUtility";
import {
  PROCESS_SUBJECT_ICONS as subjectIcons,
  PROCESS_PANEL_TABS as TABS,
  TAB_PERSIST_NAME as PERSIST_NAME,
  USER_PERMISSIONS as userPermissions,
  DASHBOARD_VIEW_TYPES as dashboardViewTypes
} from "@/utils/enumerate";
import ModalArchive from "@/views/App/ModalArchive";
import ModalWarning from "@/views/App/ModalWarning.vue";
import { createFilterData } from "@/utils/filters";
import debounce from "lodash/debounce";
import { formatPagination } from "@/utils/transformers";
import { setPersistSort } from "@/plugins/indexDB";

export default {
  name: "ProcessesArchive",

  components: {
    UnifiedFilterSearch,
    NoListMessage,
    ProcessStatus
  },

  data() {
    return {
      App,
      General,
      subjectIcons,
      userPermissions,
      showStatusDOE,
      colorStatusDOE,
      selectedProcessArchive: [],
      defaultSortField: "last_tramited_date_es",
      sortField: JSON.stringify({ default: "desc" }),
      sortOrder: ["default", "desc"],
      sortIcon: "menu-up",
      sortIconSize: "is-medium",
      currentPage: 1,
      prevIcon: "chevron-left",
      nextIcon: "chevron-right",
      perPage: 10,
      isLoading: false,
      searchValue: "",
      filterList: {},
      ignoreOrderByDefault: false
    };
  },

  computed: {
    ...mapGetters({
      archiveList: "getArchiveList",
      user: "getCurrentUser",
      hasPermission: "hasPermission",
      optionsPagination: "getItensPage",
      updateBySockets: "getUpdateBySockets",
      actualTab: "getCurrentTabProcessPanel",
      getViewSector: "getViewSectorArchive",
      isConfidentialCheck: "isConfidentialCheck",
      isContrast: "isContrast",
      isMobile: "isMobile"
    }),

    viewSector: {
      get() {
        return this.getViewSector;
      },
      set(newValue) {
        this.setViewSector(newValue);
        this.currentPage = 1;
      }
    },

    getPaginationDetails() {
      return formatPagination(
        this.archiveList,
        this.currentPage,
        this.perPage,
        "SIMPLIFIED"
      );
    },

    isValidSelection() {
      return this.selectedProcessArchive.length < 2;
    },

    filterData() {
      return createFilterData(this.filterList, "ARCHIVED");
    },

    requestBaseData() {
      let capacity = false,
        with_children = false;
      if (dashboardViewTypes[this.viewSector] !== "INDIVIDUAL") {
        capacity = true;
        with_children =
          dashboardViewTypes[this.viewSector] === "SECTOR_AND_SUBORDINATES"
            ? true
            : false;
      }
      return {
        page: this.currentPage,
        search: this.searchValue,
        order_by: this.sortField,
        capacity,
        paginator_count: this.perPage,
        filters: this.filterData,
        ignore_order_by_default: this.ignoreOrderByDefault,
        with_children
      };
    },

    inActualCapacity() {
      return this.selectedProcessArchive.every(this.checkIfAreInYourCapacity);
    },

    hasPermissionViewSector() {
      return this.hasPermission(userPermissions["SECTOR_VIEW"]);
    },

    hasPermissionViewSectorAndSubordinates() {
      return this.hasPermission(userPermissions["VIEW_SECTOR_AND_CELLS"]);
    },

    getItemsFilter() {
      return [
        "PROCESS_ORIGIN",
        "PROCESS_ORIGIN_CAPACITY",
        "PROCESS_CURRENT_CAPACITY",
        "PROCESS_DATE",
        "PROCESS_DATE_CREATED",
        "PROCESS_CCS",
        "PROCESS_ANALYSIS",
        "PROCESS_STATUS_DOE",
        "PROCESS_BOOKMARKS"
      ];
    },
    isCurrentTab() {
      return this.actualTab.value === TABS.ARCHIVED.value;
    },
    tabPersistName() {
      return `${PERSIST_NAME.PROCESS_ARCHIVED}_${this.user.id}`;
    },
    hasConfidentialSelected() {
      return this.selectedProcessArchive.some(process =>
        this.isConfidential(process)
      );
    },
    hasPermissionViewConfidential() {
      return this.hasPermission(userPermissions["VIEW_CONFIDENTIAL_PROCESS"]);
    }
  },

  watch: {
    searchValue() {
      if (this.currentPage === 1) this.getAllArchiveData();
      else this.currentPage = 1;
    },

    currentPage() {
      this.getAllArchiveData();
    },

    perPage() {
      this.getAllArchiveData();
    },

    filterData() {
      if (this.currentPage === 1) this.getAllArchiveData();
      else this.currentPage = 1;
    },

    actualTab() {
      this.selectedProcessArchive = [];
      if (this.isCurrentTab) {
        this.getAllArchiveData();
      }
    },

    archiveList: {
      handler() {
        this.selectedProcessArchive = [];
      }
    },

    updateBySockets(value) {
      if (value === "update_process_archived") {
        if (this.isCurrentTab) this.getAllArchiveData();
        this.$store.commit("clearUpdateBySockets");
      }
    },

    viewSector: {
      handler() {
        if (this.isCurrentTab) {
          this.getAllArchiveData();
        }
      }
    }
  },

  async beforeMount() {
    await this.getSortData();
    this.isCurrentTab && this.getAllArchiveData(!this.isCurrentTab);
  },

  methods: {
    ...mapMutations({
      setViewSector: "setViewSectorArchive",
      setCurrentProcess: "setCurrentProcess"
    }),

    ...mapActions({
      getSortPersist: "getPersistSortAction",
      getCompleteProcessFileStream: "getCompleteProcessFileStream",
      getProcessesCompleteFile: "getProcessesCompleteFile",
      processCapacityList: "processCapacityListRequest",
      processesRequest: "processArchiveRequest"
    }),

    getSearchValue(value) {
      this.searchValue = value;
    },

    getFilterList(filterList) {
      this.filterList = filterList;
    },

    getAllArchiveData: debounce(async function(only_count = false) {
      this.formatSort(...this.sortOrder);
      this.isLoading = true;
      if (this.observerPage)
        await this.processesRequest({ ...this.requestBaseData, only_count });
      this.isLoading = false;
    }, 500),

    addZero(number) {
      return (number < 10 ? "0" : "") + number;
    },

    getReceivedDifferenceDate(date) {
      const time = new Date(date);
      return `às ${this.addZero(time.getHours())}h ${this.addZero(
        time.getMinutes()
      )}m`;
    },

    async getProcessesListCompleteFile() {
      const processList = [];
      this.selectedProcessArchive.forEach(process => {
        processList.push({ process_id: process.id });
      });

      this.$buefy.modal.open({
        parent: this,
        component: ModalWarning,
        props: {
          title: this.General.WARNING,
          btnTypeYes: "is-warning",
          btnTypeNo: "is-primary",
          message: `${this.General.MESSAGES.ARE_YOU_SURE_YOU_WANT_EXPORT_PROCESSES}? ${this.General.MESSAGES.DISABLE_POPUP}`,
          confirm: async () => {
            await this.getProcessesCompleteFile(processList);
            this.snackToast.open({
              message: this.General.MESSAGES.PROCESSES_SUCCESSFULLY_EXPORTED,
              position: "is-top",
              type: "is-success",
              duration: 8000
            });
          }
        },
        hasModalCard: true,
        trapFocus: true
      });
    },

    showArchiveModal(process = null) {
      if (process?.id) this.selectedProcessArchive = [process];
      if (this.hasConfidentialSelected) {
        const hasConfidentialPermission = this.validateConfidentialView(
          General.TEXTS.CONFIDENTIAL_DESARCHIVE_WARNING
        );
        if (!hasConfidentialPermission) return;
      }
      this.setCurrentProcess(process);
      this.$buefy.modal.open({
        parent: this,
        component: ModalArchive,
        props: {
          listProcess: this.selectedProcessArchive,
          unarchived: true,
          onClose: async () => {
            await this.getAllArchiveData();
            await this.processCapacityList({
              capacityId: this.user.capacity.capacity_id,
              page: 1,
              only_count: true,
              order_by: JSON.stringify({ last_tramited_date_es: "desc" })
            });
            this.selectedProcessArchive = [];
          }
        },
        onCancel: () => (this.selectedProcessArchive = []),
        hasModalCard: true,
        trapFocus: true
      });
    },

    async getSortData() {
      this.observerPage = false;
      this.sortOrder = await this.getSortPersist({
        sortField: this.sortField,
        tabPersistName: this.tabPersistName
      });
      this.observerPage = true;
    },

    formatSort(field, order) {
      if (field === "default") {
        this.sortField = JSON.stringify({ [this.defaultSortField]: order });
        this.ignoreOrderByDefault = false;
      } else {
        this.sortField = JSON.stringify({ [field]: order });
        this.ignoreOrderByDefault = true;
      }
    },

    onSort(field, order) {
      this.formatSort(field, order);
      setPersistSort({ name: this.tabPersistName, sort: { [field]: order } });
      this.sortOrder = [field, order];
      this.getAllArchiveData();
    },

    applyMaskNUP(value) {
      return applyMask(NUP, value);
    },

    checkIfAreInYourCapacity(process) {
      return (
        this.user.capacity.part_id === process.capacity.entityId &&
        this.user.capacity.capacity_id === process.capacity.id
      );
    },

    secrecyName(process) {
      return process.secrecy.name || "";
    },

    isConfidential(process) {
      return this.isConfidentialCheck(process.secrecy.id);
    },

    validateConfidentialView(
      message = this.General.TEXTS.CONFIDENTIAL_VIEW_WARNING
    ) {
      if (!this.hasPermissionViewConfidential) {
        this.snackToast.open({
          message,
          position: "is-top",
          type: "is-warning",
          duration: 8000
        });
        return false;
      }
      return true;
    },

    checkIsConfidential(callback = () => null) {
      if (this.hasConfidentialSelected) {
        const hasConfidentialPermission = this.validateConfidentialView();
        if (!hasConfidentialPermission) return;

        this.$buefy.modal.open({
          parent: this,
          component: ModalWarning,
          props: {
            title: `${this.General.WARNING}!`,
            message: this.General.MESSAGES.ALERT_PROCESS_SECRECY,
            invertOutline: true,
            confirm: callback,
            buttons: [
              { label: General.YES, isConfirm: true, action: true },
              { label: General.NO, isConfirm: false, action: false }
            ]
          },
          hasModalCard: true,
          trapFocus: true
        });
      } else {
        callback();
      }
    },

    actionList(item) {
      return [
        {
          html: General.TEXTS.PDF_VIEW_HTML,
          position: this.isMobile ? "is-right" : "is-left",
          icon: "folder-search",
          callback: () => this.getCompleteProcessFileStream(item.id),
          dataCY: "view-process"
        },
        {
          label: this.General.UNARCHIVE,
          icon: "archive-arrow-up",
          iconType: this.checkIfAreInYourCapacity(item)
            ? null
            : "is-grey-light",
          callback: () =>
            this.checkIfAreInYourCapacity(item)
              ? this.showArchiveModal(item)
              : this.snackToast.open({
                  message: this.General.TEXTS.UNABLE_TO_UNARCHIVED_SINGULAR,
                  position: "is-top",
                  type: "is-danger",
                  duration: 8000
                }),
          dataCY: "unarchive-process"
        }
      ];
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/variables";

.custom-padding-mt {
  padding: 50px 0;
}

.custom-flex-item {
  margin: 0 2px;
}
</style>
